import { Link } from 'react-router-dom';
import { BlogPost } from '../../lib/api';

interface BlogCardProps {
  post: BlogPost;
}

function isNewPost(dateStr: string) {
  const postDate = new Date(dateStr);
  const now = new Date();
  const diff = (now.getTime() - postDate.getTime()) / (1000 * 60 * 60 * 24);
  return diff <= 7;
}

export default function BlogCard({ post }: BlogCardProps) {
  const isNew = isNewPost(post.created_at);
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform hover:scale-105 hover:bg-blue-50">
      <Link to={`/blog/${post.slug}`}>
        <div className="aspect-video bg-gray-100">
          <img 
            src={post.image_url || 'https://danielmtavares.com.br/images/warehouse.webp'} 
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-6">
          <div className="flex items-center mb-4">
            <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">
              {post.category}
            </span>
            {isNew && (
              <span className="ml-2 inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded">Novo</span>
            )}
            <span className="text-gray-500 text-sm ml-2">
              {new Date(post.created_at).toLocaleDateString('pt-BR')}
            </span>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2 line-clamp-2">
            {post.title}
          </h3>
          <p className="text-gray-600 mb-4 line-clamp-2">
            {post.excerpt}
          </p>
          <div className="flex items-center text-sm text-gray-500">
            <span>Por {post.author}</span>
          </div>
        </div>
      </Link>
    </div>
  );
} 